import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { toRecordKey } from '@/services/on-farm-implant';

import type { MatingRecord } from '../../types';
import { useFrozenPartialMatings } from './frozenPartialMatingsContext';

type FrozenPartialMatingCellProps = {
  data?: MatingRecord;
  innerRenderer?: (params: { data: MatingRecord }) => ReactNode;
};

export const FrozenPartialMatingCell = ({
  data,
  innerRenderer,
}: FrozenPartialMatingCellProps) => {
  const { t } = useTranslation();
  const partialMatings = useFrozenPartialMatings();
  if (!data) return null;
  const embryoCount = partialMatings.get(toRecordKey(data.id, data.accountId));
  return (
    <div className="flex items-center gap-2">
      {innerRenderer?.({ data })}
      {embryoCount ? (
        <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs whitespace-nowrap text-amber-800">
          {t('onFarmImplant.sourceCard.partialMating', { count: embryoCount })}
        </span>
      ) : null}
    </div>
  );
};
